import {generateSection} from "./util/generateSection";
import takeSnapShot from "./util/takeSnapShot";

const addSection = async ({
    sectionData,
    product,
    setSelectedSectionId
}) => {
    const section = await generateSection(sectionData, product);
    window.threeViewer.scene.add(section)
    
    // setSelectedSectionId(section.userData?.id);
    section.update()
    
    const PreviewImage = await takeSnapShot(sectionData, false)
    const thumbnail_image_url = URL.createObjectURL(PreviewImage);
    sectionData["thumbnail_image_url"] = thumbnail_image_url;
    setTimeout(() => {
        setSelectedSectionId(sectionData.sectionId);
    }, 500);
}

export default addSection;